import * as React from 'react';
import Tiles from './components/Tiles/Tiles';
import LiveChat from './components/LiveChat/LiveChat';
import './Summary.scss';
import { CLASSNAME_PREFIX } from './componentConfig';
import { H3 } from '@sitebase/ui-kit';
function Summary(_a) {
    var data = _a.data, isChatEnabled = _a.isChatEnabled, clickHandler = _a.clickHandler, translate = _a.t;
    return (React.createElement("div", { className: CLASSNAME_PREFIX + "-component" },
        React.createElement("div", null,
            React.createElement(H3, null, translate('APP_TITLE')),
            React.createElement("p", { className: CLASSNAME_PREFIX + "-component__disclaimer" },
                React.createElement("span", null,
                    translate('APP_DESCRIPTION_LINE_1'),
                    " ",
                    React.createElement("b", null, translate('APP_DESCRIPTION_LINE_2_BOLD')),
                    translate('APP_DESCRIPTION_LINE_2')))),
        React.createElement(Tiles, { data: data, clickHandler: clickHandler, t: translate }),
        isChatEnabled ? React.createElement(LiveChat, { t: translate }) : null));
}
export default Summary;
//# sourceMappingURL=Summary.js.map